import { render, staticRenderFns } from "./OrganizationManagement.vue?vue&type=template&id=22b79338&scoped=true"
import script from "./OrganizationManagement.vue?vue&type=script&lang=js"
export * from "./OrganizationManagement.vue?vue&type=script&lang=js"
import style0 from "./OrganizationManagement.vue?vue&type=style&index=0&id=22b79338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b79338",
  null
  
)

export default component.exports